import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Normaliza URLs viejas con slash final a su forma canónica sin slash.
 *
 * Tras migrar las rutas a sin trailing slash, React Router v6 todavía hace
 * match de un bookmark viejo (`/login/`) contra la ruta nueva (`/login`), pero
 * la barra de direcciones seguiría mostrando la URL vieja. Este componente, en
 * cada cambio de ruta, reemplaza la URL por la versión sin slash final
 * (preservando query string y hash), de modo que el bookmark queda actualizado.
 *
 * La raíz `/` se respeta: nunca se le quita el slash.
 */
const TrailingSlashRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== '/' && pathname.endsWith('/')) {
      const canonical = pathname.replace(/\/+$/, '');
      navigate(`${canonical}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default TrailingSlashRedirect;
